module.exports = __webpack_public_path__ + "img/strategies_distractYourself.1f43fdf2.png";